import OrderItem from './OrderItem';
import React, { useContext } from 'react';
import { handleNavigateReorder } from '../tools';
import { PATH, getRoute } from '@/utils/routes';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/reducers';
import { useSSRSelector } from '@/redux/ssrStore';
import { useRouter } from 'next/router';
import { ORDERS_LIST_TYPE } from '@/constants/order';
import { OrderContext } from '../context';

export function RenderList() {
  const router = useRouter();
  const { activeTab, orders } = useContext(OrderContext);

  const { userData, cart } = useSelector((state: RootState) => ({
    userData: state.userReducer.data,
    cart: state.cartReducer,
  }));

  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  const shouldRenderList = Array.isArray(orders) && orders.length > 0;

  function handleOrderItemClick(orderItem) {
    if (activeTab === ORDERS_LIST_TYPE.FAILED_PAYMENTS) {
      return;
    }
    router.push(
      getRoute(PATH.orderStatus(orderItem.order_hash), storeData.store_info.domain)
    );
  }

  if (!shouldRenderList) return null;

  return orders.map(([date, orders]) => {
    return (
      <div key={`${date}-order-list-wrap`}>
        <h3 className="date-btn">
          <span>{date}</span>
        </h3>
        {orders.map((orderItem, ind) => {
          return (
            <OrderItem
              key={`${ind}-order-item`}
              order={orderItem}
              isComplete={activeTab === ORDERS_LIST_TYPE.COMPLETED}
              isFailedPaymentOrder={activeTab === ORDERS_LIST_TYPE.FAILED_PAYMENTS}
              onBuyAgainClick={(e) =>
                handleNavigateReorder(e, {
                  orderItems: orderItem.items,
                  cartItems: cart.items,
                  storeData,
                  userData,
                  router,
                })
              }
              onCardClick={() => handleOrderItemClick(orderItem)}
            />
          );
        })}
      </div>
    );
  });
}

export default RenderList;
